import { render } from "./DesignDashboard.vue?vue&type=template&id=21612b45&scoped=true"
import script from "./DesignDashboard.vue?vue&type=script&lang=js"
export * from "./DesignDashboard.vue?vue&type=script&lang=js"

import "./DesignDashboard.vue?vue&type=style&index=0&id=21612b45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21612b45"]])

export default __exports__